/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */

export const getRedirectUrl = (state) => state.auth?.redirectUrl || false;

export default {};
